import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectPage from "../pages/project/page";
import PublicationsPage from "../pages/publications/page";
import PublicationDetailPage from "../pages/publications/detail";
import PressPage from "../pages/press/page";
import AboutPage from "../pages/about/page";
import ResearchFilmPage from "../pages/research-film/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/project/:slug",
    element: <ProjectPage />,
  },
  {
    path: "/publications",
    element: <PublicationsPage />,
  },
  {
    path: "/publications/:id",
    element: <PublicationDetailPage />,
  },
  {
    path: "/press",
    element: <PressPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/research-film-projects",
    element: <ResearchFilmPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;